// Sofaluz Shipping Times — JS (Alphabetical + Code Badge + TOTAL highlight)
(function(){
  // Transit (after dispatch) + region
  var DATA = {
    AT:{name:"Austria",       shipMin:2, shipMax:3, region:"MID_EU"},
    BE:{name:"Belgium",       shipMin:2, shipMax:3, region:"MID_EU"},
    CA:{name:"Canada",        shipMin:6, shipMax:9, region:"US"},
    FR:{name:"France",        shipMin:3, shipMax:4, region:"MID_EU"},
    DE:{name:"Germany",       shipMin:2, shipMax:3, region:"FAST_EU"},
    IE:{name:"Ireland",       shipMin:4, shipMax:5, region:"EU"},
    IT:{name:"Italy",         shipMin:3, shipMax:5, region:"EU"},
    NL:{name:"Netherlands",   shipMin:2, shipMax:3, region:"MID_EU"},
    ES:{name:"Spain",         shipMin:3, shipMax:4, region:"EU"},
    CH:{name:"Switzerland",   shipMin:3, shipMax:4, region:"FAST_EU"},
    UK:{name:"United Kingdom",shipMin:3, shipMax:5, region:"FAST_EU"},
    US:{name:"United States", shipMin:5, shipMax:7, region:"US"}
  };

  // Production windows by region
  var MAKE = {
    EU:      {min:9,  max:15, label:"Made for you in 9–15 business days."},
    FAST_EU: {min:8,  max:12, label:"Fast lane production: 8–12 business days."},   // UK / CH / DE
    MID_EU:  {min:10, max:12, label:"Production window: 10–12 business days."},     // FR / BE / AT / NL
    US:      {min:12, max:18, label:"Made for you in 12–18 business days."}         // US (+ CA)
  };

  // Badge code mapping
  var CODE_MAP = { US: "USA", UK: "UK" }; // others will use their two-letter code (ES, NL, DE...)

  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var sel = document.getElementById('slz-country');
    var sheet = document.getElementById('slz-sheet');
    if(!sel || !sheet) return;

    var backdrop = document.getElementById('slz-backdrop');
    var closeBtn = document.getElementById('slz-close');
    var badge = document.getElementById('slz-badge');
    var nameEl = document.getElementById('slz-name');
    var makeEl = document.getElementById('slz-make');
    var shipEl = document.getElementById('slz-ship');
    var totalEl = document.getElementById('slz-total');
    var makeCopy = document.getElementById('slz-make-copy');
    var legCopy = document.getElementById('slz-leg-copy');

    function openSheet(code){
      var d = DATA[code]; if(!d) return;
      var rule = MAKE[d.region] || MAKE.EU;

      // Badge shows ISO-ish code (USA/UK/ES/NL/DE...)
      badge.textContent = CODE_MAP[code] || code;

      nameEl.textContent = d.name;
      makeEl.textContent = rule.min + '–' + rule.max;
      shipEl.textContent = d.shipMin + '–' + d.shipMax;
      totalEl.textContent = (rule.min + d.shipMin) + '–' + (rule.max + d.shipMax);
      makeCopy.textContent = rule.label;
      legCopy.textContent = 'Travel time: ' + d.shipMin + '–' + d.shipMax + ' working days.';

      sheet.setAttribute('aria-hidden','false');

      // reset little pulse (in case theme has transitions)
      [makeEl, shipEl, totalEl].forEach(function(el){
        el.style.animation = 'none';
        requestAnimationFrame(function(){ el.style.animation = ''; });
      });

      var card = document.querySelector('#slz-sheet .slz-card');
      if(card) card.focus();
    }

    function closeSheet(){
      sheet.setAttribute('aria-hidden','true');
      sel.value = "";
    }

    // Events
    sel.addEventListener('change', function(e){ openSheet(e.target.value); });

    // Close interactions (button / backdrop / ESC)
    closeBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); closeSheet(); });
    document.addEventListener('click', function(e){ if(e.target && e.target.id === 'slz-close'){ e.preventDefault(); closeSheet(); }});
    backdrop.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeSheet(); });
  });
})();
